<template>
  <div class="px-lg-3 w-100">
    <b-form-select v-model="selectedProduct"
                   :options="getTranslatedOptions(PRODUCTS)"
                   size="md"
                   @input="onInput"
    />
  </div>
</template>
<script>
import { PRODUCTS_LIST } from '../utils/products.list'

export default {
  name: 'ProductSelector',
  data () {
    return {
      PRODUCTS: Object.values(PRODUCTS_LIST),
      selectedProduct: null
    }
  },
  methods: {
    onInput (product) {
      this.$emit('input', product)
    },
    getTranslatedOptions (options) {
      const translatedOptions = options.map(product => ({
        value: product,
        text: this.$t(`products.${product}`)
      }))

      return [
        {
          value: null,
          text: this.$t('label.selectProduct'),
          disabled: true
        },
        ...translatedOptions
      ]
    }
  }
}
</script>
